import React from "react";
import CasesTable from "@/components/CasesTable";
import { useL } from "@/context/I18nContext";

export default function SpecialistQueue() {
  const L = useL();
  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-heading text-2xl font-medium text-white">{L("Coda di lavoro", "Work queue", "Arbeitswarteschlange")}</h2>
        <p className="mt-1 text-slate-400">{L("Solo le pratiche assegnate a te.", "Only cases assigned to you.", "Nur Ihnen zugewiesene Fälle.")}</p>
      </div>
      <CasesTable endpoint="/specialist/cases" basePath="/specialist/cases" paged={false} />
    </div>
  );
}
